import React, { Fragment } from 'react';
import moment from 'moment/moment';
import { connect } from 'react-redux';
import ViewHeader from '../view-header';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';

import { processImageUpdate } from "../AdminCaseDetails/helpers";


import {
    getData,
    addBooking,
    getCase,
    addDentist,
    addPatient,
    getParentCases,
    getAllPatientsRequest,
    addVacationDaysRequest, getVacationDaysRequest, deleteVacationDayRequest,
    resetVacationsSuccess,resetVacationsDelete
} from './actions';
import {setDate, startImageUploading} from "../../../../shared/redux/actions";
import ModalComponent from '../../../../components/Modal';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import dates from 'react-big-calendar/lib/utils/dates';
import AddBookingForm from '../../../../components/Home/addBookingForm';
import Notice from "../../../../components/Notification/newNotification";
import {globals} from '../../../../../../common/constants';
import Spinner from '../../../../components/Spinner';
//Icons
import SubcaseForm from "../../../../components/SubCaseForm";
import SubcaseModalBody from "../../../../components/CreateSubcase";
import ReactTooltip from "react-tooltip";


// Custom hooks
import {
    useDashboardEventList,
    useDashboardEventStyle,
    useDashboardUnitKey,
    useDashboardCaseBlockHeaderColor,
} from "../../CustomHooks";
import "./Dashboard.scss"
import { ADD_CASE_SUCCESS_MESSAGE } from "../../../../shared/constants";
import DatePicker from "react-datepicker";
import {isNonWorkingDay, getLastLegalDays, formatDate, getNext8BusinessDays} from "../../../../helpers";
import PureBigCalendar from "./PureBigCalendar";

class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.bridgesRef = React.createRef();
        const locationState = props.history.location.state;
        this.state = {
            startDate: null,
            endDate: null,
            canNotAddVacationDays: false,
            dataProcessing: false,
            updatingVacationsDays: false,
            vacationDaysTableOptions: {
                page:1,
                noDataText: 'No vacation days were found.',
                hideSizePerPage: true,
                sizePerPage: 1,
                onSortChange: (field, order) => this.changeSortingOptions(field, order),
            },
            checkedTeeth:[],
            addingBookingInfo: {
                eightBusinessDaysFromCurrentDate: getNext8BusinessDays(),
                parent_id: null,
                patient_id: 0,
                sending_date: null,
                number_of_units: 0,
                type: '',
                notes: '',
                admin_case_notes: '',
                color: '',
                signature: '',
                license: '',
                implant: '',
                implantType: '',
                implantSize: '',
                enclosedBox: [],
                implantParts: {},
                image: [],
                date_of_return: '',
                bridges:[],
            },
            validationBooking: {
                dentistNotExists: false,
                dentist_id: false,
                patient_id: false,
                sending_date: false,
                date_of_return: false,
                number_of_units: false,
                type: false,
                implant: false,
                enclosedBox: false,
                dentist_name: false,
                dentistSelected: false,
                patient_name: false,
                implantParts:false,
            },
            implantsPartObject: {
                1: { name: 'Impression coping ', number: 0 },
                2: { name: 'Impression screw ', number: 0 },
                3: { name: 'Lab analog ', number: 0 },
                4: { name: 'Prosthetic screw ', number: 0 },
                5: { name: 'Abutment/Ti', number: 0 },
                6: { name: 'Other ', number: 0 }
            },
            enclosedBoxObject: {
                1: { name: 'Impression/master model' },
                2: { name: 'Antagonist model/impression' },
                3: { name: 'Bite' },
                4: { name: 'Pre-op/temp model/impression' },
                5: {name:  'Optical scan'},
                6: { name: 'Implant parts' },
                7: { name: 'Other ' }
            },
            dentistName: '',
            modalBodyText: '',
            cancelModal: false,
            openBookingFormAfterAddNewPatient: false,
            notValidDate: false,
            modalHeaderText: '',
            addBookingShow: false,
            dateNow: moment(),
            numberOfUnitsForPerDay: 0,
            numberOfUnitsForPerDayZirconia: 0,
            moreThenAvailableUnitsModal: false,
            dateAfter10Days: moment().businessAdd(8).toDate(),
            interval: 0,
            printModal: false,
            dentist: '',
            patient: '',
            hasErrorImages: false,
            isOpenLeaveModal: false,
            isOpenCasesDropdown: false,
            createSubcaseModal: false,
            isOpenSubcaseForm: false,
            startOfCalendarView: formatDate( "start",locationState && locationState.defaultDate ? locationState.defaultDate : undefined),
            endOfCalendarView: formatDate( "end",locationState && locationState.defaultDate ? locationState.defaultDate : undefined),
            showAdminNotesBtn: false,
            disableZirconiaType:false,
            disableMiscType: false,
            isVacationDaysModalOpen:false,
            filterData: {
                filterOptions: {},
                sortingOptions: {}
            },
        };
        this.toggleCasesDropdown = this.toggleCasesDropdown.bind(this);
        this.toggleSubcaseFormModal = this.toggleSubcaseFormModal.bind(this);
        this.eventList = [];
    }

    componentDidMount() {
        document.title = "Dashboard";
        const { startOfCalendarView, endOfCalendarView } = this.props.calendarRange;
        this.props.getVacationDays(moment(new Date()).format('YYYY-MM-DD'));
        this.props.getData(startOfCalendarView, endOfCalendarView);
        this.props.getParentCases();
        this.interval = setInterval(() => this.props.getData(startOfCalendarView, endOfCalendarView), 7000);
        this.eventList = useDashboardEventList(this.props.adminDashboard.data.events);
        this.props.getAllPatients()

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.addedVacationDays){
            Notice.addNotification('Added vacation days successfully.', 'success');
            this.props.resetVacationsSuccess();
            this.props.getVacationDays(moment(new Date()).format('YYYY-MM-DD'));
        }
        if(this.props.deletedVacationDay){
            Notice.addNotification('Deleted vacation days successfully.', 'success');
            this.props.resetVacationsDelete();
            this.props.getVacationDays(moment(new Date()).format('YYYY-MM-DD'));
        }
        if(prevProps.vacationDays !== this.props.vacationDays){
            if (this.props.vacationDays.length) {
                const lastLegalDay = getLastLegalDays(this.state.dateAfter10Days,this.props.vacationDays);
                this.setState({
                    dateAfter10Days: lastLegalDay,
                    addingBookingInfo: {
                        ...this.state.addingBookingInfo,
                        eightBusinessDaysFromCurrentDate: getNext8BusinessDays(this.props.vacationDays)
                    }
                })

            }
        }
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    toggleCasesDropdown() {
        this.setState({ isOpenCasesDropdown: !this.state.isOpenCasesDropdown })
    }

    toggleSubcaseFormModal(item) {
        if (item) {
            this.props.getCase(item.caseId)
        }
        this.setState({ isOpenSubcaseForm: false, addingBookingInfo: { ...this.state.addingBookingInfo, parent_id: item ? item.caseId : null } });
    }

    handleClose = () => {
        if (!this.state.isOpenLeaveModal && this.state.addBookingShow && !this.state.printModal) {
            this.setState(prevState => ({
                isOpenLeaveModal: !prevState.isOpenLeaveModal
            }));
        }
        else {
            this.setState(prevState => ({
                addingBookingInfo: {
                    eightBusinessDaysFromCurrentDate: prevState.addingBookingInfo.eightBusinessDaysFromCurrentDate,
                    parent_id: null,
                    patient_id: 0,
                    sending_date: null,
                    number_of_units: 0,
                    type: '',
                    notes: '',
                    admin_case_notes: '',
                    color: '',
                    signature: '',
                    license: '',
                    implant: '',
                    implantType: '',
                    implantSize: '',
                    enclosedBox: [],
                    implantParts: {},
                    image: [],
                    bridges:[],
                },
                checkedTeeth:[],
            }))
            this.resetState();
        }
    }

    handleClosVacationsModal = () => {
        this.setState({
            isVacationDaysModalOpen: false,
            canNotAddVacationDays: false,
            startDate: null,
            endDate: null,
            validateStartEnd: false
        })
    }

    resetState = (state = {}) => {
        this.setState(prevState => ({
            addBookingShow: prevState.openBookingFormAfterAddNewPatient,
            openBookingFormAfterAddNewPatient: false,
            cancelModal: false,
            printModal: false,
            moreThenAvailableUnitsModal: false,
            selectedDate: '',
            selectedDateKey: '',
            addingBookingInfo: {
                ...prevState.addingBookingInfo,
                sending_date: null,
                image: [],
            },
            validationBooking: {
                dentist_id: false,
                patient_id: false,
                sending_date: false,
                number_of_units: false,
                type: false,
                implant: false,
                enclosedBox: false,
                dentist_name: false,
                dentistSelected: false,
                patient_name: false,
                implantParts: false,
            },
            dentist: '',
            patient: '',
            isOpenLeaveModal: false,
            createSubcaseModal: false,
            isOpenSubcaseForm: false,
            dataProcessing: false,
            ...state
        }));
        const { startOfCalendarView, endOfCalendarView } = this.props.calendarRange;
        this.props.getData(startOfCalendarView, endOfCalendarView);
    }

    handleCanceling() {
        this.setState({
            isOpenSubcaseForm: false,
            createSubcaseModal: false,
            addBookingShow: false,
            cancelModal: false,
            moreThenAvailableUnitsModal: false,
            selectedDate: '',
            selectedDateKey: '',
        });
    }

    handleStay() {
        this.setState({isOpenLeaveModal: false});
    }

    cancelBooking() {
        this.setState({cancelModal: true});
    }

    get specialDays() {
        return this.props.adminDashboard.data.specialDays || []
    }

    get parentCases() {
        return this.props.adminDashboard.parentCases;
    }

    get numberOfUnits() {
        return this.props.adminDashboard.data.numberOfUnits
    }

    get patientList() {
        return this.props.adminDashboard.allPatientsList;
    }

    get dentistList() {
        return this.props.adminDashboard.data.dentists
    }

    get dentistsALL() {
        return this.props.adminDashboard.data.dentistList
    }

    addNewPatient() {
        this.setState({addNewPatient: true})
    }

    handleChangeSendingDate(sendingDate) {
        this.setState({
            addingBookingInfo: {
                ...this.state.addingBookingInfo,
                sending_date: sendingDate
            }
        });
        this.setState(prevState => ({
            validationBooking: {
                ...prevState.validationBooking,
                sending_date:  !sendingDate,
            }
        }));
    }

    handleChangeReturnDate(date) {
        this.setState({
            addingBookingInfo: {
                ...this.state.addingBookingInfo,
                date_of_return: date
            }
        });
        this.setState(prevState => ({
            validationBooking: {
                ...prevState.validationBooking,
                date_of_return:  !date,
            }
        }));
    }

    handleChangePatient(selectedOption) {
        const validationBooking = this.state.validationBooking;
        let patient_id = 0;
        if (selectedOption) {
            const match = this.patientList.find(
                entry => (entry.id === selectedOption.value));
            if (!match) {
                if (!this.state.dentist || validationBooking.dentist_name || validationBooking.dentistNotExists) {
                    validationBooking.dentistSelected = true;
                } else {
                    const data = { first_name: '', last_name: '', dentist_id: this.state.dentist.value };
                    data.first_name = selectedOption.value.split(' ').slice(0, -1).join(' ');
                    data.last_name = selectedOption.value.split(' ').slice(-1).join(' ');
                    if (!data.first_name || !data.last_name) {
                        validationBooking.patient_name = true;
                        validationBooking.dentistSelected = false;
                    }
                    else {
                        this.props.addPatient(data);
                    }
                }
            } else {
                patient_id = selectedOption.value;
            }
        }
        else {
            patient_id = 0;
        }
        this.setState(prevState => ({
            patient: selectedOption,
            validationBooking: {
                ...prevState.validationBooking,
                patient_id:  selectedOption && !selectedOption.value,
            },
            addingBookingInfo: {...prevState.addingBookingInfo, patient_id,
            }
        }));
    }

    handleChangeDentist(selectedOption) {
        const selectedDentistLicense = this.props.patientsList.data.dentistList && this.props.patientsList.data.dentistList.find(obj => obj.id === selectedOption && selectedOption.value) && this.props.patientsList.data.dentistList.find(obj => obj.id === selectedOption && selectedOption.value).license
        const validationBooking = this.state.validationBooking;
        let dentistName = '';
        if (selectedOption) {
            const match = this.dentistsALL && this.dentistsALL.find(
                entry => (entry.id === selectedOption.value));
            if (!match) {
                const data = { first_name: '', last_name: '' };
                data.first_name = selectedOption.value.split(' ').slice(0, -1).join(' ');
                data.last_name = selectedOption.value.split(' ').slice(-1).join(' ');
                if (!data.first_name || !data.last_name) {
                    validationBooking.dentist_name = true;
                    validationBooking.dentistNotExists = true;
                } else {
                    this.props.addDentist(data);
                    validationBooking.dentistSelected = false;
                    validationBooking.dentistNotExists = false;
                }
            } else {
                dentistName = selectedOption.value;
            }
        } else {
            dentistName = '';
        }

        this.setState(prevState => ({
            dentist: selectedOption,
            patient: '',
            validationBooking: {
                ...validationBooking,
                dentist_name: !selectedOption,
            },
            dentistName: dentistName,
            addingBookingInfo: {...prevState.addingBookingInfo, dentist_name: dentistName,license: selectedDentistLicense || ''
            }
        }));
    }

    makeBridge = (from,to) => {
        const bridges = this.state.addingBookingInfo.bridges;
        const checkedTeeth = this.state.checkedTeeth;
        if(from === to) {
            if(bridges.length){
                if(checkedTeeth.includes(from) && checkedTeeth.includes(to)){
                    const filteredBridge = bridges.filter((bridge)=> {
                        return bridge.from !== from
                    })
                    const filteredTeeth = checkedTeeth.filter((teeth)=>{
                        return teeth !== from;
                    })
                    this.setState({
                        checkedTeeth:filteredTeeth,
                        addingBookingInfo:{...this.state.addingBookingInfo,bridges:filteredBridge}
                    })
                } else {
                    bridges.push({from:from, to:to})
                    checkedTeeth.push(from);
                    this.setState({
                        checkedTeeth:checkedTeeth,
                        addingBookingInfo:{...this.state.addingBookingInfo,bridges:bridges}
                    })
                }
            }else {
                checkedTeeth.push(to);
                bridges.push({from:from,to:to})
                this.setState({
                    checkedTeeth:checkedTeeth,
                    addingBookingInfo:{...this.state.addingBookingInfo,bridges:bridges}
                })
            }

        } else {
            if(checkedTeeth.includes(from) && checkedTeeth.includes(to) && from !== 11 && from !== 41){
                let isBridged = false;
                const filteredBridges = bridges.filter(bridge => {
                    if (bridge.from === from && bridge.to === to) {
                        isBridged = true;
                        return false;
                    }
                    return bridge.from !== from && bridge.to !== to;
                })
                if(isBridged){
                    const filteredTeeth = checkedTeeth.filter((teeth)=>{
                        return teeth !== from && teeth !== to;
                    })
                    this.setState({
                        checkedTeeth:filteredTeeth,
                        addingBookingInfo:{
                            ...this.state.addingBookingInfo,
                            bridges: filteredBridges
                        }
                    })
                } else {
                    bridges.push({from:from,to:to});
                    this.setState({
                        addingBookingInfo:{...this.state.addingBookingInfo,bridges:bridges}
                    })
                }
            } else {
                if(from === 11){
                    let isBridged = false;
                    if(checkedTeeth.includes(from) && checkedTeeth.includes(21)){
                        const filteredBridges = bridges.filter(bridge => {
                            if (bridge.from === from && bridge.to === 21) {
                                isBridged = true;
                                return false;
                            }
                            return bridge.from !== from && bridge.to !== 21;
                        })
                        if(isBridged){
                            const filteredTeeth = checkedTeeth.filter((teeth)=>{
                                return teeth !== from && teeth !== 21;
                            })
                            this.setState({
                                checkedTeeth:filteredTeeth,
                                addingBookingInfo:{
                                    ...this.state.addingBookingInfo,
                                    bridges: filteredBridges
                                }
                            })
                        } else {
                            bridges.push({from:from, to:21});
                            checkedTeeth.push(from,21);
                            this.setState({
                                checkedTeeth:checkedTeeth,
                                addingBookingInfo:{...this.state.addingBookingInfo,bridges:bridges}
                            })
                        }
                    }else {
                        bridges.push({from:from, to:21});
                        checkedTeeth.push(from,21);
                        this.setState({
                            checkedTeeth:checkedTeeth,
                            addingBookingInfo:{...this.state.addingBookingInfo,bridges:bridges}
                        })
                    }
                } else if(from === 41){
                    let isBridged = false;
                    if(checkedTeeth.includes(from) && checkedTeeth.includes(31)){
                        const filteredBridges = bridges.filter(bridge => {
                            if (bridge.from === from && bridge.to === 31) {
                                isBridged = true;
                                return false;
                            }
                            return bridge.from !== from && bridge.to !== 31;
                        })
                        if(isBridged){
                            const filteredTeeth = checkedTeeth.filter((teeth)=>{
                                return teeth !== from && teeth !== 31;
                            })
                            this.setState({
                                checkedTeeth:filteredTeeth,
                                addingBookingInfo:{
                                    ...this.state.addingBookingInfo,
                                    bridges: filteredBridges
                                }
                            })
                        } else {
                            bridges.push({from:from, to:31});
                            checkedTeeth.push(from,31);
                            this.setState({
                                checkedTeeth:checkedTeeth,
                                addingBookingInfo:{...this.state.addingBookingInfo,bridges:bridges}
                            })
                        }
                    }else {
                        bridges.push({from:from, to:31});
                        checkedTeeth.push(from,31);
                        this.setState({
                            checkedTeeth:checkedTeeth,
                            addingBookingInfo:{...this.state.addingBookingInfo,bridges:bridges}
                        })
                    }

                } else {
                    bridges.push({from: from, to: to});
                    checkedTeeth.push(from, to);
                    this.setState({
                        checkedTeeth: checkedTeeth,
                        addingBookingInfo: {...this.state.addingBookingInfo, bridges: bridges}
                    })
                }
            }
        }
    }

    handleChangeBookingInfo(key, value, find) {
        this.setState(prevState => ({
            validationBooking: {
                ...prevState.validationBooking,
                [key]:  !value,
            }
        }));
        if (key === 'enclosedBox') {
            const enclosedBox = this.state.addingBookingInfo[key];
            const find = enclosedBox.find(item => {
                return item === value
            });
            const updateData = (find > 0) ? enclosedBox.filter(e => e !== value) : [...this.state.addingBookingInfo[key], value];

            this.setState({
                addingBookingInfo: {...this.state.addingBookingInfo, [key]: updateData}
            })
        } else if (key === 'implantParts') {
            let updateData, implantParts = this.state.addingBookingInfo[key];
            if (implantParts[value] !== undefined && !find) {
                delete implantParts[value]
                updateData = implantParts;
            } else {
                updateData = {...this.state.addingBookingInfo[key], [(find) ? find : value]: (find) ? value : 0}
            }
            this.setState({
                addingBookingInfo: {...this.state.addingBookingInfo, [key]: updateData}
            })
        } else if (key === 'image') {
            const images = this.state.addingBookingInfo.image;
            if (value.hasError) {
                this.setState({hasErrorImages: true});
            } else {
                this.setState({
                    addingBookingInfo: {...this.state.addingBookingInfo, image: [...images, ...value.currentImage]},
                    hasErrorImages: false
                })
            }
        } else if (key === 'admin_case_notes') {
            this.setState({
                ...this.state,
                addingBookingInfo: {
                    ...this.state.addingBookingInfo,
                    [key]: value
                }
            })
        } else {
            const dentistName = (key === 'patient_id') ? this.getDentistName(parseInt(value, 10)) : this.state.dentistName;
            this.setState({
                dentistName: dentistName,
                addingBookingInfo: {
                    ...this.state.addingBookingInfo,
                    [key]: value
                }
            })
        }
    }

    getDentistName(patientId) {
        const dentist = this.dentistList.find(dentist => {
            const dentistId = dentist.patients.find(item => {
                return patientId === item.id
            })
            if (dentistId !== undefined) {
                return dentistId.dentist_id === dentist.id;
            } else {
                return false;
            }

        })
        if (dentist !== undefined) {
            return dentist.first_name + ' ' + dentist.last_name
        }
    }

    hendleClickOnEvent = (event) => {
        this.props.history.push({
            pathname: '/sm-admin/case-details/' + event.caseId,
            state: { page: '/sm-admin', pageName: 'Dashboard' }
        });
    }

    clickOutside(ref) {
        ref.cancelFocusInput();
        ref.setOpen(false);
    }

    async handleSaveBooking() {
        this.props.getAllPatients();
        const bookingInfo = this.state.addingBookingInfo;
        const patient_id = bookingInfo.patient_id <= 0;
        const number_of_units = bookingInfo.number_of_units <= 0;
        const type = !(bookingInfo.type && (
            bookingInfo.type.value === 'prototype'
            || bookingInfo.type.value === 'zirconia'
            || bookingInfo.type.value === 'other'
            || bookingInfo.type.value === 'ceramic'
            || bookingInfo.type.value === 'temp'));
        const implant = !(bookingInfo.implant === '1' || bookingInfo.implant === '0');
        const sending_date = !bookingInfo.sending_date;
        const date_of_return = this.state.selectedDate ? !this.state.selectedDate : !bookingInfo.date_of_return;
        const enclosedBox = !bookingInfo.enclosedBox.length;
        const dentist_name = !bookingInfo.dentist_name;
        const implantPartValues = Object.values(bookingInfo.implantParts);
        const implantParts = implantPartValues.length > 0 && !implantPartValues.every(Boolean);
        if (patient_id || number_of_units || type || implant || sending_date || enclosedBox || date_of_return || dentist_name || implantParts) {
            this.setState({
                validationBooking: {
                    patient_id: patient_id,
                    sending_date: sending_date,
                    number_of_units: number_of_units,
                    implantParts,
                    type: type,
                    implant: implant,
                    enclosedBox: enclosedBox,
                    date_of_return: date_of_return,
                    dentist_name: dentist_name,
                }
            });
        } else {
            let modalHeaderText, modalBodyText;
            // if (((bookingInfo.type.value != 'zirconia' && bookingInfo.number_of_units > this.state.numberOfUnitsForPerDay) ||
            //     (bookingInfo.type.value == 'zirconia' && bookingInfo.number_of_units > this.state.numberOfUnitsForPerDayZirconia)) && !this.state.moreThenAvailableUnitsModal) {
            //         modalHeaderText = 'Print Booking';
            //         modalBodyText = 'Would you like to print the case?';
            //         // modalHeaderText = 'Units More Than Available';
            //         // modalBodyText = 'The number of inserted units exceeds the number of available units. The case will be pending confirmation from the lab, are you sure you want to continue ?';
            //     this.setState({
            //             // moreThenAvailableUnitsModal: true,
            //             // openBookingFormAfterAddNewPatient: true,
            //             addBookingShow: false,
            //             modalBodyText,
            //             modalHeaderText,
            //             printModal: true
            //         });
            //     this.setState({ moreThenAvailableUnitsModal: true, openBookingFormAfterAddNewPatient: true, addBookingShow: false, modalBodyText, modalHeaderText });
            // }
            if (this.state.notValidDate && !this.state.moreThenAvailableUnitsModal) {
                modalHeaderText = 'Selected Date Is Not Available';
                modalBodyText = 'There are no available units for the selected date. Do you want to book anyway?';
                this.setState({
                    moreThenAvailableUnitsModal: true,
                    openBookingFormAfterAddNewPatient: true,
                    addBookingShow: false,
                    modalBodyText,
                    modalHeaderText
                });
            } else {
                this.setState({ dataProcessing: true })
                await processImageUpdate(this.state,this.bridgesRef.current)
                const { startOfCalendarView, endOfCalendarView } = this.props.calendarRange;
                const sendingData = {
                    patient_id: bookingInfo.patient_id,
                    sending_date: moment(bookingInfo.sending_date).format('YYYY-MM-DD').toString(),
                    number_of_units: bookingInfo.number_of_units,
                    type: bookingInfo.type.value,
                    notes: bookingInfo.notes,
                    admin_case_notes: bookingInfo.admin_case_notes,
                    date_of_submission: moment(this.state.dateNow).format('YYYY-MM-DD').toString(),
                    date_of_return: moment(this.state.returnDate).format('YYYY-MM-DD').toString(),
                    status: 'scheduled',
                    isAdmin: true,
                    color: bookingInfo.color,
                    signature: bookingInfo.signature,
                    license: bookingInfo.license,
                    implant: bookingInfo.implant,
                    implantType: bookingInfo.implantType,
                    implantSize: bookingInfo.implantSize,
                    enclosedBox: bookingInfo.enclosedBox,
                    implantParts: bookingInfo.implantParts,
                    image: bookingInfo.image,
                    startDate: startOfCalendarView,
                    endDate: endOfCalendarView,
                    dentist_name: bookingInfo.dentist_name,
                    bridges: bookingInfo.bridges,
                };
                this.setState({ openBookingFormAfterAddNewPatient: false })
                this.props.addBooking(sendingData)
            }
        }
    }

    handleClickOnDay = (slotInfo) => {
        const day = moment(slotInfo.end).format("YYYY-MM-DD");
        const dayUnits = this.props.adminDashboard.data.numberOfUnits && this.props.adminDashboard.data.numberOfUnits[day] && this.props.adminDashboard.data.numberOfUnits[day];
        const disableMiscType = dayUnits && dayUnits.units === 0;
        const disableZirconiaType = dayUnits && dayUnits.units_for_zirconia === 0;

        this.setState({disableMiscType,disableZirconiaType})

        let notValidDate = false;
        const startDate = moment(slotInfo.start);
        const unitsKey = useDashboardUnitKey(slotInfo.start, this.numberOfUnits);
        const dayKey = moment(slotInfo.start).format('YYYY-MM-DD');
        let numberOfUnits = globals.NUMBER_OF_UNITS_MISC,
            numberOfUnitsZirconia = globals.NUMBER_OF_UNITS_ZIRCONIA;

        if (unitsKey !== undefined) {
            numberOfUnits = this.numberOfUnits[unitsKey].units;
            numberOfUnitsZirconia = this.numberOfUnits[unitsKey].units_for_zirconia;
        } else if (this.specialDays !== undefined && this.specialDays[dayKey] !== undefined) {
            numberOfUnits = this.specialDays[dayKey];
            numberOfUnitsZirconia = this.specialDays[dayKey].units_for_zirconia;
        }

        if (startDate <= this.state.dateNow) {
            notValidDate = true;
            Notice.addNotification("You are trying to select a passed date. Passed dates are not available for booking. Please select an upcoming date.",'error')
        } else {
            notValidDate = false;
        }


        this.setState({
            notValidDate: notValidDate,
            addBookingShow: !notValidDate,
            selectedDateKey: moment(startDate).format('YYYY-MM-DD'),
            selectedDate: moment(startDate).format('MMM DD,YYYY'),
            returnDate: moment(startDate).format('L'),
            numberOfUnitsForPerDay: numberOfUnits,
            numberOfUnitsForPerDayZirconia: numberOfUnitsZirconia
        });
        clearInterval(this.interval);
    }

    componentWillReceiveProps(nextProps, nextState) {
        if (this.state.selectedDateKey !== undefined) {
            const selectDate = this.state.selectedDateKey;
            if (nextProps.adminDashboard.data.numberOfUnits && nextProps.adminDashboard.data.numberOfUnits[selectDate] !== undefined) {
                this.setState({numberOfUnitsForPerDay: nextProps.adminDashboard.data.numberOfUnits[selectDate].units});
            }
        }
        if (nextProps.adminDashboard.addIsSuccess !== this.props.adminDashboard.addIsSuccess) {
            this.setState({
                dentist: {...this.state.dentist, value:nextProps.adminDashboard.dentistInfo && nextProps.adminDashboard.dentistInfo.id},
                dentistName: this.state.dentist ? this.state.dentist.label : '',
                addingBookingInfo: {
                    ...this.state.addingBookingInfo,
                    dentist_name: this.state.dentist.label,
                    dentistSelected: false
                }
            });
            Notice.addNotification('Dentist is successfully added.', 'success');
        } else if (nextProps.adminDashboard.addIsSuccess === false) {
            Notice.addNotification('Something went wrong.', 'error');
        }
        if (nextProps.adminDashboard.patientAdded !== this.props.adminDashboard.patientAdded) {
            this.setState({
                addingBookingInfo: {
                    ...this.state.addingBookingInfo,
                    patient_id: this.state.patient ? nextProps.adminDashboard.patientInfo && nextProps.adminDashboard.patientInfo.id : 0
                },
            });
            Notice.addNotification('Patient is successfully added.', 'success');
        } else if (nextProps.adminDashboard.patientAdded === false) {
            Notice.addNotification('Something went wrong.', 'error');
        }
        if (this.props.imageUpload.uploadingComplete && !this.props.imageUpload.uploadingImages && !this.props.imageUpload.hasErrors && this.state.addBookingShow) {
            this.resetState({
                addBookingShow: false,
                moreThenAvailableUnitsModal: false,
                printModal: true,
                modalHeaderText: 'Print Booking',
                modalBodyText: 'Would you like to print the case?',
                addingBookingInfo: {
                    eightBusinessDaysFromCurrentDate: this.state.addingBookingInfo.eightBusinessDaysFromCurrentDate,
                    parent_id: null,
                    patient_id: 0,
                    sending_date: null,
                    number_of_units: 0,
                    type: '',
                    notes: '',
                    color: '',
                    signature: '',
                    license: '',
                    implant: '',
                    implantType: '',
                    implantSize: '',
                    enclosedBox: [],
                    implantParts: {},
                    image: [],
                    bridges: [],
                    checkedTeeth: [],
                },
            });
            if (Object.keys(nextProps.imageUpload.achievedUploads).length) {
                Notice.addNotification('Images successfully uploaded.', 'success');
            }
        }

        if (nextProps.adminDashboard.added === true) {
            this.props.startImageUploading({caseId: nextProps.adminDashboard.addedData, isAdmin: true , getCase: false });
            Notice.addNotification(ADD_CASE_SUCCESS_MESSAGE, 'success');
            this.props.getCase(nextProps.adminDashboard.addedData);
        } else if (nextProps.adminDashboard.added === false) {
            Notice.addNotification('Your session is expired.', 'error');
            this.setState({
                moreThenAvailableUnitsModal: false,
                addBookingShow: this.state.openBookingFormAfterAddNewPatient,
                openBookingFormAfterAddNewPatient: false,
                dataProcessing: false,
                validationBooking: {
                    patient_id: false,
                    number_of_units: false,
                    implantParts: false,
                    type: false,
                    implant: false,
                    sending_date: false,
                    enclosedBox: false,
                    dentist_name: false,
                    dentistSelected: false,
                    patient_name: false
                }
            });
        }
        if (nextProps.adminDashboard.gotCaseDetails && !this.props.adminDashboard.gotCaseDetails && this.state.addingBookingInfo.parent_id && !this.state.printModal) {
            this.setState({isOpenSubcaseForm: true, createSubcaseModal: false});
        }

        if (nextProps.adminDashboard.data.events !== this.props.adminDashboard.data.events) {
            if (this.state.updatingVacationsDays) {
                const { startDate, endDate } = this.state;
                if (startDate && endDate) {
                    const overlap = nextProps.adminDashboard.data.events.some(element => {
                        let eventStartDate = moment(element.startDate);
                        let eventEndDate = moment(element.endDate);

                        if (eventStartDate.isSame(eventEndDate, 'day')) {
                            eventEndDate = eventEndDate.endOf('day');
                        }

                        const startDateValue = moment(startDate);
                        const endDateValue = moment(endDate);

                        return (
                            startDateValue.isBetween(eventStartDate, eventEndDate, null, '[]') ||
                            endDateValue.isBetween(eventStartDate, eventEndDate, null, '[]') ||
                            (eventStartDate.isSameOrAfter(startDateValue) && eventEndDate.isSameOrBefore(endDateValue))
                        );
                    });

                    if (!overlap) {
                        this.props.addVacationDays({start: startDate, end: endDate});
                    }
                    this.setState({validateStartEnd: false, canNotAddVacationDays: overlap, updatingVacationsDays: false});
                }
            } else {
                this.eventList = useDashboardEventList(nextProps.adminDashboard.data.events);
            }
        }
    }

    renderEventHeader = (props) => {
        var numberOfUnits;
        const unitsKey = useDashboardUnitKey(props.date, this.numberOfUnits);
        const dayKey = moment(props.date).format('YYYY-MM-DD');
        let misc = globals.NUMBER_OF_UNITS_MISC,
            zirconia = globals.NUMBER_OF_UNITS_ZIRCONIA,
            bookedMisc = 0,
            bookedZirc = 0;
        let availableMisc = 0;
        let availableZirc = 0;
        if (unitsKey !== undefined) {
            misc = this.numberOfUnits[unitsKey].units;
            zirconia = this.numberOfUnits[unitsKey].units_for_zirconia
            bookedMisc = this.numberOfUnits[unitsKey].booked;
            bookedZirc = this.numberOfUnits[unitsKey].bookedZirconia;
            availableMisc = this.numberOfUnits[unitsKey].units;
            availableZirc = this.numberOfUnits[unitsKey].units_for_zirconia;
        } else if (this.specialDays[dayKey] !== undefined) {
            misc = this.specialDays[dayKey].units;
            zirconia = this.specialDays[dayKey].units_for_zirconia || 0;
            availableMisc = this.specialDays[dayKey].units;
            availableZirc = this.specialDays[dayKey].units_for_zirconia;
        } else {
            availableMisc = misc;
            availableZirc = zirconia;
        }
        const statusOfDay = (unitsKey !== undefined) ? this.numberOfUnits[unitsKey].status : 'scheduled';
        const className = useDashboardCaseBlockHeaderColor(
            props.date, this.state.dateAfter10Days, misc, zirconia, statusOfDay,this.props.vacationDays,this.state.addingBookingInfo.eightBusinessDaysFromCurrentDate
        )

        return (
            <div className={"custom-day-header-" + className}>
                <small
                    className="custom-day-header">
                    <Fragment>
                        <Fragment>
                            M: <span data-for="booked" data-tip='Booked'>{bookedMisc}</span>/
                            <span data-for="available" data-tip='Available'>{misc}</span>
                            <span> </span>
                        </Fragment>
                        <Fragment>Z/C: <span data-for="booked" data-tip='Booked'>{bookedZirc}</span>/
                            <span data-for="available" data-tip='Available'>{zirconia}</span>
                            <ReactTooltip place="top" id="booked" type="light" effect="float"/>
                            <ReactTooltip place="top" id="available" type="light" effect="float"/>
                        </Fragment>
                    </Fragment>
                </small>
                {props.label}
            </div>

        )
    }

    removeImage(name) {
        this.setState({
            addingBookingInfo: {
                ...this.state.addingBookingInfo,
                image: this.state.addingBookingInfo.image.filter(image => image.filename !== name)
            }
        });
    }

    onDateRangeChange = (date, view, action) => {
        clearInterval(this.interval);
        const startOfCalendarView = moment(dates.firstVisibleDay(date)).format('YYYY-MM-DD');
        const endOfCalendarView = moment(dates.lastVisibleDay(date)).format('YYYY-MM-DD');
        this.props.onDateChange({
            startOfCalendarView,
            endOfCalendarView,
            defaultDate: date,
        })
        this.props.getData(startOfCalendarView, endOfCalendarView);
    };

    handleStartDate = (date) => {
        let stateUpdatePayload = {};
        if(date > this.state.endDate){
            stateUpdatePayload = { endDate: date }
        }
        this.setState({
            startDate: date,
            ...stateUpdatePayload,
            canNotAddVacationDays: false
        })
    }

    handleEndDate = (date) => {
        this.setState({endDate: date, canNotAddVacationDays: false})
    }

    handleSaveVacationDays = () => {
        const  start = this.state.startDate;
        const  end = this.state.endDate;
        if (!start || !end) {
            this.setState({validateStartEnd: true});
        } else {
            this.setState({ updatingVacationsDays: true });
            this.props.getData(
                formatDate("start",start),
                formatDate("end",end)
            )
        }
    }

    openVacationDaysModal = () => {
        this.setState({ isVacationDaysModalOpen: true });
    }

    getFilterDefaultValue = (filterName, fieldType) => {
        const filterData = this.props.filterData;
        if(fieldType === 'text') {
            return filterData && filterData[filterName] ? filterData[filterName].value : null
        }
        return filterData && filterData[filterName] ? moment(filterData[filterName].value[fieldType]) : null
    }

    idFormatter = (row) => {
        return moment(row).format('MM-DD-YYYY');
    }

    deleteVacationDay = (id) => {
        this.props.deleteVacationDay(id);
    }

    actionsFormatter = (cell,row) => {
        return (
            <div className="user-actions">
                <span
                    data-tip="Delete"
                    className="kr kr-delete"
                    onClick={(event) => this.deleteVacationDay(row.id)}
                />
                <ReactTooltip place="top" type="light" effect="float"/>
            </div>
        )
    }

    setFocusedField = (fieldName) => {
        this.setState({focusedField: fieldName});
    }

    changeFilterOptions = (key, value) => {
        const filterOptions = {
            ...this.state.filterData.filterOptions,
            [key]: value
        }
        if (value.length === 0) {
            delete filterOptions[key];
        }
        this.setState({
                filterData: {...this.state.filterData, filterOptions}
            },
            () => {
                this.props.getVacationDays(filterOptions);
            });

    }

    changeSortingOptions = (field, order) => {
        this.setState({
            filterData: {
                sortingOptions: {
                    [field]: order
                },
                filterOptions: {
                    ...this.state.filterData.filterOptions
                }
            },
            option: {
                ...this.state.option,
                page: 1
            }
        }, () => {
            const page = this.state.option.page;
            const {filterOptions, sortingOptions} = this.state.filterData;
            this.props.getVacationDays({page, sortingOptions, filterOptions});
        });
    }

    render() {
        const header = 'DASHBOARD';
        const desc = 'Latest statistics & summary';
        const locationState = this.props.history.location.state;
        return (
            <div className="view">
                <ViewHeader
                    header={header}
                    desc={desc}
                    disabled={!this.parentCases.length}
                    showVacationsButton={true}
                    openVacationsModal={this.openVacationDaysModal}
                    openModal={() => this.setState({ createSubcaseModal: true })}
                    openConvertModal={() => this.setState({ addBookingShow: true })}
                    primaryButtonName={"Book Case"}
                    secondaryButtonName={"Create Subcase"}
                    showPrimary={true}
                    showSecondary={true}
                />
                <div className="view-content view-dashboard dashboard-calendar">
                    <div className="dashboard-block">
                        <div className="calendarBlock">
                            <div className="calendarRow">
                                <div className="dashboard-block__container">
                                    {
                                        (this.props.adminDashboard.loading === true || this.props.vacationDaysLoading) ?
                                            <Spinner />
                                            :
                                            <PureBigCalendar
                                                events={this.eventList}
                                                onNavigate={this.onDateRangeChange}
                                                startAccessor='startDate'
                                                endAccessor="endDate"
                                                onSelectSlot={this.handleClickOnDay}
                                                onSelectEvent={this.hendleClickOnEvent}
                                                selectable={true}
                                                defaultView='month'
                                                defaultDate={this.props.calendarRange.defaultDate}
                                                longPressThreshold={250}
                                                eventPropGetter={useDashboardEventStyle}
                                                timeslots={8}
                                                popup={true}
                                                renderEventHeader={this.renderEventHeader}
                                            />
                                    }
                                </div>
                                {
                                    <ModalComponent
                                        dialogClassName="book-case__dialog"
                                        modalHeaderStyle="modalHeaderDefault"
                                        headerTitle="Book Case"
                                        modalBody={
                                            <AddBookingForm
                                                loading={this.props.addingDataLoading}
                                                disableZirconiaType={this.state.disableZirconiaType}
                                                disableMiscType={this.state.disableMiscType}
                                                onClickOutside={(ref) => this.clickOutside(ref)}
                                                cancelBooking={() => this.cancelBooking()}
                                                makeBridge={(from,to)=>this.makeBridge(from,to)}
                                                checkedTeeth={this.state.checkedTeeth}
                                                handleChange={(key, value, find = null) => this.handleChangeBookingInfo(key, value, find)}
                                                handleChangePatient={(selectedOption) => this.handleChangePatient(selectedOption)}
                                                handleChangeDentist={(selectedOption) => this.handleChangeDentist(selectedOption)}
                                                handleChangeSendingDate={(sendingDate) => this.handleChangeSendingDate(sendingDate)}
                                                handleChangeReturnDate={(date) => this.handleChangeReturnDate(date)}
                                                selectedDate={this.state.selectedDate}
                                                selectedDateKey={this.state.selectedDateKey}
                                                dateOfSubmittion={moment(this.state.dateNow).format('DD/MM/YYYY')}
                                                dentist={this.state.dentistName}
                                                dentistInfo={this.state.dentist}
                                                patientList={this.patientList}
                                                handleSaveBooking={() => this.handleSaveBooking()}
                                                validation={this.state.validationBooking}
                                                numberOfUnits={this.state.addingBookingInfo.number_of_units}
                                                numberOfUnitsForPerDay={this.state.numberOfUnitsForPerDay}
                                                implantsPart={this.state.addingBookingInfo.implantParts}
                                                enclosedBox={this.state.addingBookingInfo.enclosedBox}
                                                implantsPartObject={this.state.implantsPartObject}
                                                enclosedBoxObject={this.state.enclosedBoxObject}
                                                data={this.state.addingBookingInfo}
                                                isAdmin={true}
                                                hasErrorImages={this.state.hasErrorImages}
                                                dentistList={this.dentistList}
                                                dentistsAll={this.dentistsALL}
                                                patient={this.state.patient}
                                                removeImage={(fileName) => this.removeImage(fileName)}
                                                listNumberOfUnits={this.numberOfUnits}
                                                specialDays={this.specialDays}
                                                adminCaseNotes={this.state.patient && this.state.patient.admin_case_notes}
                                                showAdminNotesBtn={this.state.showAdminNotesBtn}
                                                date_of_return={this.state.returnDate}
                                                vacationDays={this.props.vacationDays}
                                                bridgesRef={this.bridgesRef}
                                            />
                                        }
                                        show={this.state.addBookingShow}
                                        handleClose={() => this.handleClose()}
                                        buttonText="Save"
                                        buttonFunction={() => this.handleSaveBooking()}
                                        addBookingForm={true}
                                        saveDisabled={this.props.adminDashboard.addingDataLoading || this.state.dataProcessing}
                                    />
                                }
                            </div><br/>
                            {
                                this.state.cancelModal &&
                                <ModalComponent
                                    modalHeaderStyle="modalHeaderDefault"
                                    headerTitle="Cancel Booking"
                                    modalBody="Data you have inserted will be lost. Are you sure you want to leave?"
                                    show={this.state.cancelModal}
                                    handleClose={() => this.handleClose()}
                                    buttonText="Cancel"
                                    buttonFunction={() => this.handleCanceling()}
                                />
                            }
                            {
                                this.state.isVacationDaysModalOpen &&
                                <ModalComponent
                                    modalHeaderStyle="modalHeaderDefault"
                                    headerTitle="Add Vacation Days"
                                    modalTitle="subcaseModalTitle modalTitle"
                                    infoModal={false}
                                    buttonDisabled={this.state.canNotAddVacationDays || this.state.updatingVacationsDays}
                                    buttonText='Save'
                                    errorMessage={this.state.canNotAddVacationDays && 'A case is scheduled during this period. Please update the case or select other dates.'}
                                    modalBody={
                                        <div className='vacation_days_block'>
                                            <div className="vacation_days_calendar">
                                                <div className={`cl-item units__date react-calendar ${(this.state.validateStartEnd) ? "has-error" : ""}`}>
                                                    <label className="date-title">Choose start date</label>
                                                    <span className="kr kr-calendar" />
                                                    <DatePicker
                                                        dayClassName={date => isNonWorkingDay(date,this.props.vacationDays) ? 'disabled_date' : ''}
                                                        selected={this.state.startDate}
                                                        onChange={(date) => this.handleStartDate(date)}
                                                        selectsStart
                                                        className="form-control"
                                                        startDate={this.state.startDate}
                                                        placeholderText="DD/MM/YYYY"
                                                    />
                                                    {this.state.validateStartEnd && <span className="error-message">Start Date field is required.</span>}
                                                </div>
                                                <div className={`cl-item units__date react-calendar ${(this.state.validateStartEnd) ? "has-error" : ""}`}>
                                                    <label className="date-title">Choose end date</label>
                                                    <span className="kr kr-calendar" />
                                                    <DatePicker
                                                        dayClassName={date => isNonWorkingDay(date,this.props.vacationDays) ? 'disabled_date' : ''}
                                                        selected={this.state.endDate}
                                                        onChange={(date) => this.handleEndDate(date)}
                                                        selectsEnd
                                                        className="form-control"
                                                        endDate={this.state.endDate}
                                                        minDate={this.state.startDate}
                                                        placeholderText="DD/MM/YYYY"
                                                    />
                                                    {this.state.validateStartEnd && <span className="error-message">End Date field is required.</span>}
                                                </div>
                                            </div>
                                            <div className='vacation_days_table'>
                                                <BootstrapTable
                                                    pagination
                                                    bordered={false}
                                                    className="dentist-mobile-table"
                                                    ref={table => this.table = table}
                                                    data={this.props.vacationDays}
                                                    options={this.state.vacationDaysTableOptions}
                                                    remote
                                                    responsive
                                                    striped
                                                    ignoreSinglePage
                                                >
                                                    <TableHeaderColumn
                                                        width="50"
                                                        isKey
                                                        dataField='start'
                                                        dataFormat={this.idFormatter}
                                                        dataSort={false}
                                                    >
                                                        Start
                                                    </TableHeaderColumn>
                                                    <TableHeaderColumn
                                                        width="50"
                                                        dataField='end'
                                                        dataFormat={this.idFormatter}
                                                        dataSort={false}
                                                    >
                                                        End
                                                    </TableHeaderColumn>
                                                    <TableHeaderColumn
                                                        width="50"
                                                        dataField='createdAt'
                                                        dataFormat={this.idFormatter}
                                                        dataSort={false}
                                                    >
                                                        Created
                                                    </TableHeaderColumn>
                                                    <TableHeaderColumn
                                                        width="20"
                                                        dataField='cases'
                                                        dataFormat={this.actionsFormatter}
                                                    ></TableHeaderColumn>
                                                </BootstrapTable>
                                                {/*<Pagination*/}
                                                {/*    locale={{ prev_page: 'prev', next_page: 'next'}}*/}
                                                {/*    className="pagination__rc"*/}
                                                {/*    showLessItems*/}
                                                {/*    hideOnSinglePage*/}
                                                {/*    onChange={this.state.vacationDaysTableOptions.onPageChange}*/}
                                                {/*    current={this.state.vacationDaysTableOptions.page}*/}
                                                {/*    total={this.props.vacationDays.length}*/}
                                                {/*    pageSize={this.state.vacationDaysTableOptions.sizePerPage}*/}
                                                {/*/>*/}
                                            </div>
                                        </div>
                                    }
                                    dialogClassName={"vacation__modal"}
                                    show={this.state.isVacationDaysModalOpen}
                                    handleClose={() => this.handleClosVacationsModal()}
                                    buttonFunction={()=>this.handleSaveVacationDays()}
                                />
                            }
                            {
                                this.state.createSubcaseModal &&
                                <ModalComponent
                                    modalHeaderStyle="modalHeaderDefault"
                                    headerTitle="Create Subcase"
                                    modalTitle="subcaseModalTitle modalTitle"
                                    infoModal={true}
                                    modalBody={<SubcaseModalBody
                                        toggleCasesDropdown={this.toggleCasesDropdown}
                                        isOpenCasesDropdown={this.state.isOpenCasesDropdown}
                                        toggleSubcaseFormModal={this.toggleSubcaseFormModal}
                                        eventList={this.parentCases}
                                    />}
                                    dialogClassName={"subcase__modal__dialog"}
                                    show={this.state.createSubcaseModal}
                                    handleClose={() => this.handleClose()}
                                />
                            }
                            {
                                this.state.isOpenLeaveModal &&
                                <ModalComponent
                                    modalHeaderStyle="modalHeaderDefault"
                                    headerTitle="Close form"
                                    modalBody="The case booking is not saved. Do you really want to leave?"
                                    show={this.state.isOpenLeaveModal}
                                    handleClose={() => this.handleStay()}
                                    buttonText="Leave"
                                    buttonFunction={() => this.handleClose()}
                                    isLeaveModal={true}
                                />
                            }
                            {
                                this.state.moreThenAvailableUnitsModal &&
                                <ModalComponent
                                    modalHeaderStyle="modalHeaderDefault"
                                    headerTitle={this.state.modalHeaderText}
                                    modalBody={this.state.modalBodyText}
                                    show={this.state.moreThenAvailableUnitsModal}
                                    handleClose={() => this.handleClose()}
                                    buttonText="Book Now"
                                    buttonDisabled={this.props.adminDashboard.addingDataLoading}
                                    buttonFunction={() => this.handleSaveBooking()}
                                />
                            }
                            {
                                this.state.printModal &&
                                <ModalComponent
                                    dialogClassName="print-modal"
                                    modalHeaderStyle="modalHeaderDefault"
                                    headerTitle={this.state.modalHeaderText}
                                    modalBody={this.state.modalBodyText}
                                    printCase={this.state.printModal}
                                    show={this.state.printModal}
                                    caseDetails={this.props.adminDashboard.caseList}
                                    handleClose={this.handleClose}
                                    buttonText="Yes"
                                    isAdmin={true}
                                />
                            }
                        </div>
                        <div className="info-block">
                            <span className="kr kr-info" />
                            <span className="info-text">Tap & hold on the cell to book a new case.</span>
                        </div>
                        <div className="admin-dashboard-colors">
                            <div className="colored-block">
                                <div className="colored-block__item pink">
                                    <span>Pink</span>
                                    <p>
                                        Pink color means vacation days marked on calendar.
                                    </p>
                                </div>
                                <div className="colored-block__item green">
                                    <span>Green</span>
                                    <p>
                                        Green colour means there is a sufficient number of units available (the number is
                                        displayed on the calendar). You can book more units than available. However, your
                                        booking will be sent for a confirmation from the lab.
                                    </p>
                                </div>
                                <div className="colored-block__item orange">
                                    <span>Orange</span>
                                    <p>
                                        Orange colour means a small number of units is left available. (the number is
                                        displayed
                                        on the calendar). You can still book more units than available. However, your
                                        booking
                                        will be sent for a confirmation from the lab.
                                    </p>
                                </div>
                                <div className="colored-block__item red">
                                    <span>Red</span>
                                    <p>
                                        Red colour means no units are available for booking.
                                    </p>
                                </div>
                                <div className="colored-block__item black">
                                    <span>Black</span>
                                    <p>
                                        Black colour means all the units are booked, however need to be confirmed by
                                        administrator. Note: if booking is rejected than units will again become available.
                                    </p>
                                </div>
                            </div>
                            {
                                this.state.isOpenSubcaseForm ?
                                    <SubcaseForm
                                        caseDetails={this.props.adminDashboard.caseList.caseDetails}
                                        parent_id={this.state.addingBookingInfo.parent_id}
                                        isAdmin={true}
                                        dashboard={this.props.adminDashboard}
                                        dashboardData={this.props.adminDashboard.data}
                                        toggleSubcaseFormModal={this.toggleSubcaseFormModal}
                                        getData={this.props.getData}
                                        isOpenSubcaseForm={this.state.isOpenSubcaseForm}
                                        addPatient={this.props.addPatient}
                                        addDentist={this.props.addDentist}
                                        addBooking={this.props.addBooking}
                                        saveDisabled={this.props.adminDashboard.addingDataLoading}
                                        minDateForSubcase={this.props.adminCaseDetails.caseList.minDateForSubcase}
                                        vacationDays={this.props.vacationDays}
                                        checkedTeeth={this.state.checkedTeeth}
                                        data={this.state.addingBookingInfo}
                                        bridges={this.state.addingBookingInfo.bridges}
                                        makeBridge={(from,to)=>this.makeBridge(from,to)}
                                    />
                                    : ''
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return ({
        imageUpload: state.imageUploadReducer,
        calendarRange: state.global.calendarRange,
        addedVacationDays: state.adminDashboard.addedVacationDays,
        deletedVacationDay: state.adminDashboard.deletedVacationDay,
        vacationDays: state.adminDashboard.vacationDays,
        vacationDaysLoading: state.adminDashboard.vacationDaysRequestLoading,
        addingDataLoading: state.adminDashboard.addingDataLoading,
        adminDashboard: state.adminDashboard,
        adminCaseDetails: state.adminCaseDetails,
        patientsList: state.adminDashboard
    });
}

const mapDispatchToProps = dispatch => {
    return {
        getData: (startOfCalendarView, endOfCalendarView) => dispatch(getData(startOfCalendarView, endOfCalendarView)),
        addBooking: (data) => {
            dispatch(addBooking(data));
        },
        getCase: (caseId) => {
            dispatch(getCase(caseId));
        },
        addDentist: (data) => {
            dispatch(addDentist(data));
        },
        addPatient: (data) => {
            dispatch(addPatient(data));
        },
        getParentCases: () => {
            dispatch(getParentCases());
        },
        getAllPatients: () => dispatch(getAllPatientsRequest()),
        addVacationDays: (data) => dispatch(addVacationDaysRequest(data)),
        getVacationDays: () => dispatch(getVacationDaysRequest(moment(new Date()).format('YYYY-MM-DD'))),
        deleteVacationDay: (data) => dispatch(deleteVacationDayRequest(data)),
        resetVacationsSuccess: () => dispatch(resetVacationsSuccess()),
        resetVacationsDelete: () => dispatch(resetVacationsDelete()),
        onDateChange: (data) => dispatch(setDate(data)),
        startImageUploading: (data) => {
            dispatch(startImageUploading(data))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);




// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/dashboard/index.js